import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    ring: {
      fill: "none",
      stroke: "#bbb",
      strokeWidth: "1px"
    },
    axis: {
      fill: "none",
      stroke: "#bbb",
      strokeWidth: "1px"
    },
    text: {
      pointerEvents: "none",
      userSelect: "none",
      fill: theme.palette.text.primary,
      fontSize: "25px",
      fontWeight: 800,
      opacity: 0.7
    }
  }),
  { name: "PluginTechRadarGrid" }
);
const RadarGrid = (props) => {
  const { radius, rings } = props;
  const classes = useStyles(props);
  const makeRingNode = (ringIndex, ringRadius) => [
    /* @__PURE__ */ React.createElement(
      "circle",
      {
        key: `c${ringIndex}`,
        cx: 0,
        cy: 0,
        r: ringRadius,
        className: classes.ring
      }
    ),
    /* @__PURE__ */ React.createElement(
      "text",
      {
        key: `t${ringIndex}`,
        y: ringRadius !== void 0 ? -ringRadius + 42 : void 0,
        textAnchor: "middle",
        className: classes.text,
        style: { fill: rings[ringIndex].color },
        "data-testid": "radar-ring-heading"
      },
      rings[ringIndex].name
    )
  ];
  const axisNodes = [
    // X axis
    /* @__PURE__ */ React.createElement(
      "line",
      {
        key: "x",
        x1: 0,
        y1: -radius,
        x2: 0,
        y2: radius,
        className: classes.axis,
        "data-testid": "radar-grid-x-line"
      }
    ),
    // Y axis
    /* @__PURE__ */ React.createElement(
      "line",
      {
        key: "y",
        x1: -radius,
        y1: 0,
        x2: radius,
        y2: 0,
        className: classes.axis,
        "data-testid": "radar-grid-y-line"
      }
    )
  ];
  const ringNodes = rings.map((r) => r.outerRadius).map((ringRadius, ringIndex) => makeRingNode(ringIndex, ringRadius));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, axisNodes.concat(...ringNodes));
};

export { RadarGrid as default };
//# sourceMappingURL=RadarGrid.esm.js.map
